module.exports = __webpack_public_path__ + "static/media/prune.f04f629e.svg";